// frontend-web/src/pages/Student/QuizPage.jsx
import React, { useEffect, useState, useRef } from "react";
import api from "../../api";
import { useNavigate, useParams } from "react-router-dom";

export default function QuizPage() {
  const { id } = useParams();
  const nav = useNavigate();

  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [timeLeft, setTimeLeft] = useState(0);
  const [loading, setLoading] = useState(true);

  // prevent double submit
  const submittedRef = useRef(false);

  // =============================
  // LOAD EXAM
  // =============================
  useEffect(() => {
    loadExam();
    // eslint-disable-next-line
  }, [id]);

  const loadExam = async () => {
    try {
      setLoading(true);

      const res = await api.get(
        `/student/mega-scholarship/${id}/start`
      );

      setQuestions(res.data.questions || []);

      // minutes → seconds
      const seconds = (res.data.duration_minutes || 0) * 60;
      setTimeLeft(seconds);

    } catch (err) {
      alert(err.response?.data?.error || "Exam not available");
      nav("/student/scholarship-list");
    } finally {
      setLoading(false);
    }
  };

  // =============================
  // TIMER
  // =============================
  useEffect(() => {
    if (loading) return;

    if (timeLeft <= 0) {
      if (!submittedRef.current) {
        submitExam(true);
      }
      return;
    }

    const timer = setTimeout(() => {
      setTimeLeft(t => t - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [timeLeft, loading]);

  // =============================
  // SUBMIT EXAM
  // =============================
  const submitExam = async (auto = false) => {
    if (submittedRef.current) return;
    submittedRef.current = true;

    try {
      await api.post(
        `/student/mega-scholarship/${id}/submit`,
        { answers }
      );

      // ✅ CORRECT RESULT ROUTE
      nav(`/student/result/mega/${id}`, { replace: true });

    } catch (err) {
      alert(err.response?.data?.error || "Submit failed");
      submittedRef.current = false;
    }
  };

  if (loading) return <p>Loading exam...</p>;

  return (
    <div style={{ padding: 30 }}>
      <h2>📝 Mega Scholarship Exam</h2>

      <h3 style={{ color: timeLeft < 60 ? "red" : "black" }}>
        ⏱ Time Left: {Math.floor(timeLeft / 60)}:
        {String(timeLeft % 60).padStart(2, "0")}
      </h3>

      <hr />

      {questions.map((q, i) => (
        <div
          key={q.id}
          style={{
            marginBottom: 20,
            padding: 15,
            border: "1px solid #ddd",
            borderRadius: 6
          }}
        >
          <strong>
            Q{i + 1}. {q.text}
          </strong>

          {["A", "B", "C", "D"].map(opt => (
            <div key={opt}>
              <label>
                <input
                  type="radio"
                  name={`q-${q.id}`}
                  checked={answers[q.id] === opt}
                  onChange={() =>
                    setAnswers(prev => ({
                      ...prev,
                      [q.id]: opt
                    }))
                  }
                />{" "}
                {opt}: {q[`option_${opt.toLowerCase()}`]}
              </label>
            </div>
          ))}
        </div>
      ))}

      <button
        onClick={() => submitExam(false)}
        style={{
          padding: "10px 20px",
          fontSize: 16,
          background: "#02884e",
          color: "white",
          border: "none",
          borderRadius: 6,
          cursor: "pointer"
        }}
      >
        ✅ Submit Exam
      </button>
    </div>
  );
}
